// extracted by mini-css-extract-plugin
export var animatedSkeletonBlock = "_3n-1";
export var movingGradient = "_3n-4";
export var movingGradientBlock = "_3n-2";
export var skeleton = "_3n-0";
export var skeletonText = "_3n-3";